import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export const updateUserData = "updateUserData"
export const updateUserPermission = "updateMobilePicture"
export default new Vuex.Store({
  state: {
    userInfo: {},
    mobile_picture: true,
    mobile_file: true,
  },
  getters: {
  },
  mutations: {
    // 更新用户消息
    [updateUserData](state, userInfo) {
      state.userInfo = userInfo
    },
    // 更新图片,文件权限
    [updateUserPermission](state, data = []) {
      state.mobile_picture = data.includes("MOBILE_PICTURE")
      state.mobile_file = data.includes("MOBILE_FILE")
    }
  },
  actions: {

  }
})
